const Welcome = () => {
    return (<div className="welcome mt-5">
        <p style={{color: 'black'}} className="tx-black">
            Bienvenido al panel de administracion de <span className="tx-red">Quinek</span>.<br/><br/>
            Desde aqui podras agregar/modificar/eliminar:
            <br/>
            <strong>Restaurantes</strong>, <strong>Platillos</strong>, <strong>Telefonos</strong>, <strong>Ubicaciones</strong>, <strong>Diseños</strong> y <strong>Recomendaciones</strong>.
            <br/>
            <br/>
            En fin, hacer de todo para administrar el negocio.
        </p>
    </div>);
}

export default Welcome;